import { ProcessorSwitch } from '../../atoms/processor-switch';
import { CollectTerminalJustifi } from './collect-terminal-justifi';
import { CollectTerminalStripe } from './collect-terminal-stripe';

export const CollectTerminalSwitch = () => {
  return <ProcessorSwitch stripeContent={CollectTerminalStripe} justifiContent={CollectTerminalJustifi} />;
};
